import { lt } from '@mews/framework';
import { useDialogForm } from '@mews-commander/form';
import { DataTestId } from '@mews-commander/enums';
import { FormValues } from './schema';
import { CreatePaymentPolicyFormContent } from './PaymentPolicyFormContent';

interface UseCreatePaymentPolicyDialogFormProps {
    handleSubmit: (formValues: FormValues) => Promise<unknown>;
}

export const useCreatePaymentPolicyDialogForm = ({ handleSubmit }: UseCreatePaymentPolicyDialogFormProps) =>
    useDialogForm({
        id: 'create-payment-policy',
        title: lt('PaymentPolicyNew'),
        saveLabel: lt('Create'),
        submitButtonDataTestId: DataTestId.CreatePaymentPolicy,
        renderForm: (props) => <CreatePaymentPolicyFormContent onSubmit={handleSubmit} {...props} />,
    });
